import { ProfileManager } from '@/shared/lib/profileManager';
import { Stream } from '@/scenarios/legacy-player/types/config';

import { transfromAudio } from '../../feature-player/utils/config/transform-audio';
import { transformSubtitles } from '../../feature-player/utils/config/transform-subtitles';
import { getEmptyPreferredTracks } from '../../feature-player/utils/config/get-empty-preferred-tracks';
import { getPuidAndFrom } from '../../feature-player/utils/config/get-puid-and-from';
import { TelemetryContentPlace, TelemetryContentType } from '../../Player';
import { trailerStartPositionVar } from '../../movie-trailer-player/utils/trailer-start-position-var';
import { PlayerBaseInfoContent } from '../../player-manager/context/PlayerBaseInfoProvider';

import { getTrailerContentId } from './get-trailer-content-id';

interface Dependencies {
    profileManager: ProfileManager;
}

export const getTrailerPlayerConfig = (baseInfo: PlayerBaseInfoContent, deps: Dependencies) => {
    const preferredTracks = getEmptyPreferredTracks();
    const additionalParams = getPuidAndFrom(deps);

    let streams: Stream[] = [];

    if (baseInfo?.__typename === 'OttTrailer' && baseInfo?.streams) {
        streams = baseInfo.streams.reduce<Stream[]>((acc, stream) => {
            if (stream) {
                acc.push({
                    url: stream.uri,
                    audio: transfromAudio(stream?.streamMeta?.audioMetas),
                    subtitles: transformSubtitles(stream?.streamMeta?.subtitleMetas),
                });
            }

            return acc;
        }, []);
    }

    const source = {
        streams,
        userPreferences: {
            preferredTracks,
        },
        id: getTrailerContentId(baseInfo),
        additionalParams: {
            ...additionalParams,
            from_block: TelemetryContentPlace.Trailer,
            stream_block: TelemetryContentType.Trailer,
        },
        startPosition: trailerStartPositionVar.get(),
    };

    return [source];
};
